// frontend/src/pages/SignupForm.js
import React, { useState } from 'react';
import '../styles/SignupPage.css'; // Import the CSS file

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const initialState = {
  tenant_name: '',
  username: '',
  password: '',
  industry: '',
  address: '',
  country: '',
  contact_person: '',
  email: '',
  phone: ''
};

export default function SignupForm() {
  const [form, setForm] = useState(initialState);
  const [status, setStatus] = useState(''); // For messages (e.g., 'Submitting...', 'Signup successful!', 'Signup failed.')

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prevForm => ({ ...prevForm, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Submitting...');
    try {
      const response = await fetch(`${BASE_URL}/api/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await response.json();

      if (response.ok && data.success) { // Check if response was OK (2xx) and backend reported success
        setStatus('Signup successful! Check your email to verify your account.');
        setForm(initialState); // Reset form on success
      } else {
        // Display error message from backend response or a generic error
        setStatus(data.error || 'Signup failed.');
      }
    } catch (err) {
      setStatus('Could not connect to server.');
      console.error("Fetch error during signup:", err);
    }
  };

  return (
    <div className="signup-container"> {/* Use CSS class */}
      {/* --- LOGO ADDED HERE --- */}
      <div className="signup-logo-container"> {/* New div for logo styling */}
        <img src="../img/LogicHub.png" alt="LogicHub Logo" className="signup-logo" />
      </div>
      {/* --- END LOGO --- */}
      <h2 className="signup-header">Sign Up for Your Trial</h2>

      {status && (
        <div className={`signup-message ${status.startsWith('Signup successful') ? 'success' : 'error'}`}>
          {status}
        </div>
      )}

      <form onSubmit={handleSubmit} className="signup-form"> {/* Use form class for styling */}
        <div className="form-group">
          <label htmlFor="tenant_name">Organisation / Tenant Name</label>
          <input 
            type="text" 
            id="tenant_name"
            name="tenant_name" 
            placeholder="e.g., Logic Hub Solutions" 
            value={form.tenant_name} 
            onChange={handleChange} 
            required 
          />
        </div>
        <div className="form-group">
          <label htmlFor="username">Admin Username</label>
          <input 
            type="text" 
            id="username"
            name="username" 
            placeholder="e.g., lgs-admin" 
            value={form.username} 
            onChange={handleChange} 
            required 
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Admin Password</label>
          <input 
            type="password" 
            id="password"
            name="password" 
            placeholder="Enter a strong password" 
            value={form.password} 
            onChange={handleChange} 
            required 
          />
        </div>
        <div className="form-group">
          <label htmlFor="industry">Industry</label>
          <input 
            type="text" 
            id="industry"
            name="industry" 
            placeholder="e.g., Finance" 
            value={form.industry} 
            onChange={handleChange} 
          />
        </div>
        <div className="form-group">
          <label htmlFor="address">Address</label>
          <input 
            type="text" 
            id="address"
            name="address" 
            placeholder="e.g., 123 Main St" 
            value={form.address} 
            onChange={handleChange} 
          />
        </div>
        <div className="form-group">
          <label htmlFor="country">Country</label>
          <input 
            type="text" 
            id="country"
            name="country" 
            placeholder="e.g., USA" 
            value={form.country} 
            onChange={handleChange} 
          />
        </div>
        <div className="form-group">
          <label htmlFor="contact_person">Contact Person</label>
          <input 
            type="text" 
            id="contact_person"
            name="contact_person" 
            placeholder="e.g., Jane Doe" 
            value={form.contact_person} 
            onChange={handleChange} 
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Contact Email</label>
          <input 
            type="email" 
            id="email"
            name="email" 
            placeholder="e.g., jane.doe@acme.com" 
            value={form.email} 
            onChange={handleChange} 
            required 
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input 
            type="tel" 
            id="phone"
            name="phone" 
            placeholder="e.g., +1234567890" 
            value={form.phone} 
            onChange={handleChange} 
          />
        </div>
        
        <button type="submit" className="submit-button"> {/* Use class for button styling */}
          Sign Up & Start Free Trial
        </button>
      </form>
    </div>
  );
}